export enum VideoType {
  Ad,
  Trailer,
}
